export const SET_CURRENT_ACTIVITY = 'SET_CURRENT_ACTIVITY'
export const SET_CURRENT_ACTIVITY_STUDENT_ATTEMPTS_DATA =
  'SET_CURRENT_ACTIVITY_STUDENT_ATTEMPTS_DATA'
export const SET_CURRENT_ACTIVITY_STATE = 'SET_CURRENT_ACTIVITY_STATE'
export const SET_CURRENT_MAUTHOR = 'SET_CURRENT_MAUTHOR'
export const SET_CURRENT_PAGE_MAUTHOR = 'SET_CURRENT_PAGE_MAUTHOR'
export const SET_CURRENT_SECTION = 'SET_CURRENT_SECTION'
export const SET_CURRENT_UNIT = 'SET_CURRENT_UNIT'
export const SET_CURRENT_USER_BOOK_INFO = 'SET_CURRENT_USER_BOOK_INFO'
export const SET_BOOK_STRUCTURE = 'SET_BOOK_STRUCTURE'
export const SET_HIGHLIGHTS = 'SET_HIGHLIGHTS'
export const SET_OUTDATED_HIGHLIGHTS = 'SET_OUTDATED_HIGHLIGHTS'
export const SET_USER_FLAGS = 'SET_USER_FLAGS'
export const RESET_ACTIVITY_DATA = 'RESET_ACTIVITY_DATA'
export const RESET_CURRENT_ACTIVITY_STATE = 'RESET_CURRENT_ACTIVITY_STATE'
export const SET_CUSTOM_MODAL = 'SET_CUSTOM_MODAL'
export const SET_THIRD_PARTY_VISITED_LINKS = 'SET_THIRD_PARTY_VISITED_LINKS'
export const SET_ACTIVITY_STATUS = 'SET_ACTIVITY_STATUS'
export const SET_AUDIO_PLAYED = 'SET_AUDIO_PLAYED'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_SNACKBAR_NAVV2 = 'SET_SNACKBAR_NAVV2'
export const SET_HIGHLIGHTS_ERROR = 'SET_HIGHLIGHTS_ERROR'
export const SET_USER_ACCESSIBILITY_SETTINGS = 'SET_USER_ACCESSIBILITY_SETTINGS'
export const SET_LINKS = 'SET_LINKS'
export const SET_INDEX_OPEN_BLACKLIST = 'SET_CONTENT_INDEX_OPEN'
export const SET_SIDE_BAR_OPEN = 'SET_SIDE_BAR_OPEN'
export const SET_SECTION_FEEDBACKS = 'SET_SECTION_FEEDBACKS'
export const SET_ATTEMPT_MODAL_DATA = 'SET_ATTEMPT_MODAL_DATA'
export const SET_SIDE_BAR_SELECTED_TAB = 'SET_SIDE_BAR_SELECTED_TAB'
export const SET_IS_SEARCH_CONTENT_OPEN = 'SET_IS_SEARCH_CONTENT_OPEN'
export const SET_IS_OPEN_DOT_MENU = 'SET_IS_OPEN_DOT_MENU'
export const SET_SECTION_CONTENT_RESTRICTION_POLICIES = 'SET_SECTION_CONTENT_RESTRICTION_POLICIES'

export function setCurrentUserBookInfo(payload) {
  return {
    payload,
    type: SET_CURRENT_USER_BOOK_INFO,
  }
}

export function setCurrentActivity(payload) {
  return {
    payload,
    type: SET_CURRENT_ACTIVITY,
  }
}

export function setCurrentActivityState(payload) {
  return {
    payload,
    type: SET_CURRENT_ACTIVITY_STATE,
  }
}

export function setCurrentActivityStudentAttemptsData(payload) {
  return {
    payload,
    type: SET_CURRENT_ACTIVITY_STUDENT_ATTEMPTS_DATA,
  }
}

export function setCurrentMauthor(payload) {
  return {
    payload,
    type: SET_CURRENT_MAUTHOR,
  }
}

export function setCurrentPageMauthor(payload) {
  return {
    payload,
    type: SET_CURRENT_PAGE_MAUTHOR,
  }
}

// First section is the primary one, the rest are the visible ones that are not primary.
// Primary section is the one that defines the current position in the book
export function setActiveSections(payload) {
  return {
    payload: payload,
    type: SET_CURRENT_SECTION,
  }
}

export function setCurrentUnit(payload) {
  return {
    payload,
    type: SET_CURRENT_UNIT,
  }
}

export function setBookStructure(payload) {
  return {
    payload,
    type: SET_BOOK_STRUCTURE,
  }
}

export function setHighlights(payload) {
  return {
    payload,
    type: SET_HIGHLIGHTS,
  }
}

export function setOutdatedHighlights(payload) {
  return {
    payload,
    type: SET_OUTDATED_HIGHLIGHTS,
  }
}

export function setHighlightsError(payload) {
  return {
    payload,
    type: SET_HIGHLIGHTS_ERROR,
  }
}

export function setUserFlags(payload) {
  return {
    payload,
    type: SET_USER_FLAGS,
  }
}

export function setIsOpenDotMenu(payload) {
  return {
    payload,
    type: SET_IS_OPEN_DOT_MENU,
  }
}

export function setUserAccessibilitySettings(payload) {
  return {
    payload,
    type: SET_USER_ACCESSIBILITY_SETTINGS,
  }
}

export function resetCurrentActivityState(payload) {
  return {
    payload,
    type: RESET_CURRENT_ACTIVITY_STATE,
  }
}

export function resetActivityData(payload) {
  return {
    payload,
    type: RESET_ACTIVITY_DATA,
  }
}

export function setThirdPartyVisitedLinks(payload) {
  return {
    payload,
    type: SET_THIRD_PARTY_VISITED_LINKS,
  }
}

export function setActivityStatus(payload) {
  return {
    payload,
    type: SET_ACTIVITY_STATUS,
  }
}

export function setAudiosIdPlayed(payload) {
  return {
    payload,
    type: SET_AUDIO_PLAYED,
  }
}

export function setSearch(payload) {
  return {
    payload,
    type: SET_SEARCH,
  }
}

export function setSnackbar(payload) {
  return {
    payload,
    type: SET_SNACKBAR_NAVV2,
  }
}

export function setLinks(payload) {
  return {
    payload,
    type: SET_LINKS,
  }
}

export function setIndexOpenBlacklist(payload) {
  return {
    payload,
    type: SET_INDEX_OPEN_BLACKLIST,
  }
}

export function setSideBarOpen(payload) {
  return {
    payload,
    type: SET_SIDE_BAR_OPEN,
  }
}

export function setSideBarSelectedTab(payload) {
  return {
    payload,
    type: SET_SIDE_BAR_SELECTED_TAB,
  }
}

export function setSectionFeedbacks(payload) {
  return {
    payload,
    type: SET_SECTION_FEEDBACKS,
  }
}

export function setAttemptModalData(payload) {
  return {
    payload,
    type: SET_ATTEMPT_MODAL_DATA,
  }
}

export function setIsSearchContentOpen(payload) {
  return {
    payload,
    type: SET_IS_SEARCH_CONTENT_OPEN,
  }
}

export function setSectionContentRestrictionPolicies(payload) {
  return {
    payload,
    type: SET_SECTION_CONTENT_RESTRICTION_POLICIES,
  }
}
